import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "mc_admin_token";
export const getToken = () => sessionStorage.getItem(TOKEN_KEY);
export const setToken = (t) => sessionStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => sessionStorage.removeItem(TOKEN_KEY);
const authHeader = () => ({ Authorization: `Bearer ${getToken()}` });

export const createBooking = (data) => axios.post(`${API}/bookings`, data).then((r) => r.data);

export const createApplication = (data) => {
  const fd = new FormData();
  fd.append("name", data.name || "");
  fd.append("email", data.email || "");
  fd.append("phone", data.phone || "");
  fd.append("city", data.city || "");
  fd.append("experience", data.experience || "");
  fd.append("availability", data.availability || "");
  if (data.cv) fd.append("cv", data.cv);
  return axios.post(`${API}/applications`, fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};

export const createContact = (data) => axios.post(`${API}/contact`, data).then((r) => r.data);

export const getBookings = () => axios.get(`${API}/bookings`, { headers: authHeader() }).then((r) => r.data);
export const getApplications = () => axios.get(`${API}/applications`, { headers: authHeader() }).then((r) => r.data);
export const getContacts = () => axios.get(`${API}/contact`, { headers: authHeader() }).then((r) => r.data);
export const cvUrl = (id) => `${API}/applications/${id}/cv`;
export const downloadCv = async (id, filename) => {
  const res = await axios.get(cvUrl(id), { responseType: "blob", headers: authHeader() });
  const url = window.URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename || `cv-${id}`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

// Content overrides / admin
export const getOverrides = () => axios.get(`${API}/content/overrides`).then((r) => r.data);
export const adminLogin = (email, password) => axios.post(`${API}/admin/login`, { email, password }).then((r) => r.data);
export const adminMe = () => axios.get(`${API}/admin/me`, { headers: authHeader() }).then((r) => r.data);
export const putOverrides = (lang, data) => axios.put(`${API}/admin/overrides`, { lang, data }, { headers: authHeader() }).then((r) => r.data);
export const submitIndexNow = () => axios.post(`${API}/admin/indexnow`, {}, { headers: authHeader() }).then((r) => r.data);
export const updateStatus = (collection, id, status) =>
  axios.put(`${API}/admin/${collection}/${id}/status`, { status }, { headers: authHeader() }).then((r) => r.data);
export const sendBookingConfirmation = (id) =>
  axios.post(`${API}/admin/bookings/${id}/send-confirmation`, {}, { headers: authHeader() }).then((r) => r.data);
export const setArchived = (collection, id, archived) =>
  axios.put(`${API}/admin/${collection}/${id}/archive`, { archived }, { headers: authHeader() }).then((r) => r.data);
export const approveApplication = (id, approved) =>
  axios.put(`${API}/admin/applications/${id}/approve`, { approved }, { headers: authHeader() }).then((r) => r.data);
export const deleteItem = (collection, id) =>
  axios.delete(`${API}/admin/${collection}/${id}`, { headers: authHeader() }).then((r) => r.data);
export const getCleaners = () => axios.get(`${API}/admin/cleaners`, { headers: authHeader() }).then((r) => r.data);
export const approveCleaner = (id, approved) =>
  axios.put(`${API}/admin/cleaners/${id}/approve`, { approved }, { headers: authHeader() }).then((r) => r.data);
export const deleteCleaner = (id) =>
  axios.delete(`${API}/admin/cleaners/${id}`, { headers: authHeader() }).then((r) => r.data);
export const getWorklogs = () => axios.get(`${API}/admin/worklogs`, { headers: authHeader() }).then((r) => r.data);
export const adminAddWorklog = (bookingId, data) => axios.post(`${API}/admin/bookings/${bookingId}/worklogs`, data, { headers: authHeader() }).then((r) => r.data);
export const adminDeleteWorklog = (bookingId, logId) => axios.delete(`${API}/admin/bookings/${bookingId}/worklogs/${logId}`, { headers: authHeader() }).then((r) => r.data);
export const adminUpdateWorklog = (bookingId, logId, data) => axios.put(`${API}/admin/bookings/${bookingId}/worklogs/${logId}`, data, { headers: authHeader() }).then((r) => r.data);
export const getClosedMonths = () => axios.get(`${API}/admin/closed-months`, { headers: authHeader() }).then((r) => r.data.months);
export const setMonthClosed = (month, closed) => axios.put(`${API}/admin/closed-months/${month}`, { closed }, { headers: authHeader() }).then((r) => r.data.months);
export const inviteApplicant = (id) =>
  axios.post(`${API}/admin/applications/${id}/invite`, {}, { headers: authHeader() }).then((r) => r.data);

export const getInvoiceSettings = () => axios.get(`${API}/admin/invoice-settings`, { headers: authHeader() }).then((r) => r.data);
export const saveInvoiceSettings = (data) => axios.put(`${API}/admin/invoice-settings`, data, { headers: authHeader() }).then((r) => r.data);
export const getInvoices = (month) => axios.get(`${API}/admin/invoices`, { params: { month }, headers: authHeader() }).then((r) => r.data);
export const sendInvoice = (id, month, message = "") => axios.post(`${API}/admin/invoices/${id}/send`, { message }, { params: { month }, headers: authHeader() }).then((r) => r.data);
export const adjustInvoice = (id, month, hours, note = "") => axios.put(`${API}/admin/invoices/${id}/adjust`, { hours, note }, { params: { month }, headers: authHeader() }).then((r) => r.data);
export const invoicePdf = async (id, month, invoiceNo) => {
  const res = await axios.get(`${API}/admin/invoices/${id}/pdf`, { params: { month }, responseType: "blob", headers: authHeader() });
  const url = window.URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url; a.download = `rechnung-${invoiceNo || id}.pdf`;
  document.body.appendChild(a); a.click(); a.remove();
  window.URL.revokeObjectURL(url);
};
export const exportPayroll = async (format, month) => {
  const res = await axios.get(`${API}/admin/payroll/export`, { params: { format, month }, responseType: "blob", headers: authHeader() });
  const url = window.URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url; a.download = `lohn-${month || "alle"}.${format}`;
  document.body.appendChild(a); a.click(); a.remove();
  window.URL.revokeObjectURL(url);
};
export const sendLogReminders = () => axios.post(`${API}/admin/send-log-reminders`, {}, { headers: authHeader() }).then((r) => r.data);
export const unassignBooking = (id) => axios.post(`${API}/admin/bookings/${id}/unassign`, {}, { headers: authHeader() }).then((r) => r.data);
export const assignBooking = (id, cleaner_id) => axios.post(`${API}/admin/bookings/${id}/assign`, { cleaner_id }, { headers: authHeader() }).then((r) => r.data);
export const adminSetShift = (id, payload) => axios.put(`${API}/admin/bookings/${id}/shift`, payload, { headers: authHeader() }).then((r) => r.data);
export const getSchedule = () => axios.get(`${API}/admin/schedule`, { headers: authHeader() }).then((r) => r.data);
export const scheduleOpenPdf = async (week) => {
  const res = await axios.get(`${API}/admin/schedule/pdf${week ? `?week=${week}` : ""}`, { responseType: "blob", headers: authHeader() });
  const url = window.URL.createObjectURL(res.data);
  window.open(url, "_blank");
  setTimeout(() => window.URL.revokeObjectURL(url), 60000);
};
export const adminBookingMessage = (id, text) => axios.post(`${API}/admin/bookings/${id}/message`, { text }, { headers: authHeader() }).then((r) => r.data);
export const adminCleanerMessage = (id, text) => axios.post(`${API}/admin/cleaners/${id}/message`, { text }, { headers: authHeader() }).then((r) => r.data);
export const sendCleanerOnboarding = (id) => axios.post(`${API}/admin/cleaners/${id}/onboarding`, {}, { headers: authHeader() }).then((r) => r.data);
export const markBookingRead = (id) => axios.post(`${API}/admin/bookings/${id}/read`, {}, { headers: authHeader() }).then((r) => r.data);
export const markCleanerRead = (id) => axios.post(`${API}/admin/cleaners/${id}/read`, {}, { headers: authHeader() }).then((r) => r.data);
export const setContractStatus = (id, received) => axios.put(`${API}/admin/cleaners/${id}/contract-status`, { received }, { headers: authHeader() }).then((r) => r.data);
export const sendAhvReminders = () => axios.post(`${API}/admin/send-ahv-reminders`, {}, { headers: authHeader() }).then((r) => r.data);

// Unread chat helper: count messages from the other side not yet seen by `viewer`
export const unreadCount = (messages, readAt, viewer) => {
  const last = (readAt || {})[viewer] || "";
  return (messages || []).filter((m) => m.sender !== viewer && (!last || (m.created_at || "") > last)).length;
};
export const exportWorklogs = async (format, month) => {
  const res = await axios.get(`${API}/admin/worklogs/export`, {
    params: { format, month }, responseType: "blob", headers: authHeader(),
  });
  const url = window.URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = `rapport-${month || "alle"}.${format}`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

// ---- Cleaner portal (separate token) ----
const CTOKEN_KEY = "mc_cleaner_token";
export const getCleanerToken = () => sessionStorage.getItem(CTOKEN_KEY);
export const setCleanerToken = (t) => sessionStorage.setItem(CTOKEN_KEY, t);
export const clearCleanerToken = () => sessionStorage.removeItem(CTOKEN_KEY);
const cHeader = () => ({ Authorization: `Bearer ${getCleanerToken()}` });

export const cleanerRegister = (data) => axios.post(`${API}/cleaner/register`, data).then((r) => r.data);
export const cleanerLogin = (email, password) => axios.post(`${API}/cleaner/login`, { email, password }).then((r) => r.data);
export const cleanerForgotPassword = (email) => axios.post(`${API}/cleaner/forgot-password`, { email }).then((r) => r.data);
export const cleanerCheckReset = (token) => axios.get(`${API}/cleaner/reset-token/${token}`).then((r) => r.data);
export const cleanerResetPassword = (token, password) => axios.post(`${API}/cleaner/reset-password`, { token, password }).then((r) => r.data);
export const cleanerMe = () => axios.get(`${API}/cleaner/me`, { headers: cHeader() }).then((r) => r.data);
export const cleanerSetAhv = (ahv_number, address) => axios.put(`${API}/cleaner/ahv`, { ahv_number, address }, { headers: cHeader() }).then((r) => r.data);
export const cleanerSetAvailability = (weekly_hours, days, note) => axios.put(`${API}/cleaner/availability`, { weekly_hours, days, note }, { headers: cHeader() }).then((r) => r.data);
export const cleanerMarkRead = () => axios.post(`${API}/cleaner/read`, {}, { headers: cHeader() }).then((r) => r.data);
export const cleanerJobRead = (id) => axios.post(`${API}/cleaner/jobs/${id}/read`, {}, { headers: cHeader() }).then((r) => r.data);
export const cleanerContractPdf = async () => {
  const res = await axios.get(`${API}/cleaner/contract.pdf`, { responseType: "blob", headers: cHeader() });
  const url = window.URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url; a.download = "arbeitsvertrag-mycleaner.pdf";
  document.body.appendChild(a); a.click(); a.remove();
  window.URL.revokeObjectURL(url);
};
export const cleanerJobs = () => axios.get(`${API}/cleaner/jobs`, { headers: cHeader() }).then((r) => r.data);
export const cleanerMyJobs = () => axios.get(`${API}/cleaner/my-jobs`, { headers: cHeader() }).then((r) => r.data);
export const cleanerAccept = (id) => axios.post(`${API}/cleaner/jobs/${id}/accept`, {}, { headers: cHeader() }).then((r) => r.data);
export const cleanerRelease = (id) => axios.post(`${API}/cleaner/jobs/${id}/release`, {}, { headers: cHeader() }).then((r) => r.data);
export const cleanerSetFirstVisit = (id, payload) => axios.put(`${API}/cleaner/jobs/${id}/first-visit`, payload, { headers: cHeader() }).then((r) => r.data);
export const cleanerLog = (id, entry) => axios.post(`${API}/cleaner/jobs/${id}/log`, entry, { headers: cHeader() }).then((r) => r.data);
export const cleanerMessage = (id, text) => axios.post(`${API}/cleaner/jobs/${id}/message`, { text }, { headers: cHeader() }).then((r) => r.data);
export const cleanerGetMessages = () => axios.get(`${API}/cleaner/messages`, { headers: cHeader() }).then((r) => r.data);
export const cleanerSupportMessage = (text) => axios.post(`${API}/cleaner/messages`, { text }, { headers: cHeader() }).then((r) => r.data);

// ---- Customer booking self-service (magic link, no login) ----
export const getBookingAccess = (token) => axios.get(`${API}/booking-access/${token}`).then((r) => r.data);
export const cancelBookingAccess = (token) => axios.post(`${API}/booking-access/${token}/cancel`, {}).then((r) => r.data);
export const sendBookingMessage = (token, text) => axios.post(`${API}/booking-access/${token}/message`, { text }).then((r) => r.data);
export const markBookingAccessRead = (token) => axios.post(`${API}/booking-access/${token}/read`, {}).then((r) => r.data);
